/*
* 2007-2016 PrestaShop
*
* NOTICE OF LICENSE
*
* This source file is subject to the Academic Free License (AFL 3.0)
* that is bundled with this package in the file LICENSE.txt.
* It is also available through the world-wide-web at this URL:
* http://opensource.org/licenses/afl-3.0.php
* If you did not receive a copy of the license and are unable to
* obtain it through the world-wide-web, please send an email
* to license@prestashop.com so we can send you a copy immediately.
*
* DISCLAIMER
*
* Do not edit or add to this file if you wish to upgrade PrestaShop to newer
* versions in the future. If you wish to customize PrestaShop for your
* needs please refer to http://www.prestashop.com for more information.
*
*  @author PrestaShop SA <contact@prestashop.com>
*  @copyright  2007-2016 PrestaShop SA
*  @license    http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
*  International Registered Trademark & Property of PrestaShop SA
*/
import { triggerAddToCartAnimation, triggerAddToCartButtonAnimation } from "../../../resources/js/animated-buttons";

$(document).ready(function () {

    ajaxCart.overrideButtonsInThePage();

    var current_timestamp = parseInt(new Date().getTime() / 1000);

    /* roll over cart */
    var cart_block = new HoverWatcher('#header .cart-popup');
    var shopping_cart = new HoverWatcher('#header .shopping_cart');
    var is_touch_enabled = false;

    if ('ontouchstart' in document.documentElement)
        is_touch_enabled = true;

    $(document).on('click', '#layer_cart .cross, #layer_cart .continue, .layer_cart_overlay', function (e) {
        e.preventDefault();
        $('.layer_cart_overlay').hide();
        $('#layer_cart').fadeOut('fast');
    });

    $('#columns #layer_cart, #columns .layer_cart_overlay').detach().prependTo('#columns');
    ajaxCart.refresh();
});

//JS Object : update the cart by ajax actions
var ajaxCart = {
    nb_total_products: 0,
    //override every button in the page in relation to the cart
    overrideButtonsInThePage: function () {
        //for every 'add' buttons...
        $(document).off('click', '.product-list__item__add-to-cart-button').on('click', '.product-list__item__add-to-cart-button', function (e) {
            e.preventDefault();

            const header = document.querySelector('#header');
            if(header){
                header.classList.remove("sticky");
            }

            triggerAddToCartButtonAnimation(this);

            const isMobile = $(this).data('is-mobile')
            const idProduct = parseInt($(this).data('id-product'));
            const idProductAttribute = parseInt($(this).data('id-product-attribute'));

            if (($(`#product_search_modal_Search_${idProduct}`).data('bs.modal') || {})._isShown) {
                $(`#product_search_modal_Search_${idProduct}`).modal('hide');
            }

            if (($(`#product_search_modal_Category_${idProduct}`).data('bs.modal') || {})._isShown) {
                $(`#product_search_modal_Category_${idProduct}`).modal('hide');
            }

            let quantity = 1;
            if (isMobile) {
                quantity = parseInt($('#count_' + idProduct + '_' + idProductAttribute + '_mobile').val());
            } else {
                quantity = parseInt($('#count_' + idProduct + '_' + idProductAttribute).val());
            }

            let minimalQuantity = parseInt($(this).data('minimal_quantity'));
            const queryId = $(this).data('query-id');
            const objectId = $(this).data('object-id');
            let position = $(this).data('position');

            if (!minimalQuantity)
                minimalQuantity = 1;
            if ($(this).prop('disabled') != 'disabled')
                ajaxCart.add(idProduct, idProductAttribute, false, this, quantity);

            //reset the counter to 1 again
            $('#count_' + idProduct + '_' + idProductAttribute).val(1);

            setQueryIdInLocalStorage(objectId, position, queryId);

        });
        //for product page 'add' button...
        if ($('.cart-popup').length) {
            $(document).off('click', '#add_to_cart button').on('click', '#add_to_cart button', function (e) {
                e.preventDefault();
                var id_product = parseInt($('#product_page_product_id').val());
                var id_product_attribute = parseInt($('#idCombination').val());
                var quantity = parseInt($('#quantity_wanted').val());
                ajaxCart.add(id_product, id_product_attribute, true, null, quantity, null);
            });
        }

        $('.cart-popup .button--clear').on('click', function () {
            $('.cart-popup').modal('hide');
        });

    },

    // try to expand the cart
    expand: function () {

    },

    // try to collapse the cart
    collapse: function () {

    },
    // Fix display when using back and previous browsers buttons
    refresh: function () {
        return new Promise((resolved) => {
            $.ajax({
                type: 'POST',
                headers: { "cache-control": "no-cache" },
                url: (typeof (baseUri) !== 'undefined') ? baseUri + '?rand=' + new Date().getTime() : '',
                async: true,
                cache: false,
                dataType: "json",
                data: (typeof (static_token) !== 'undefined') ? 'controller=cart&ajax=true&token=' + static_token : '',
                success: function(jsonData) {
                    ajaxCart.updateCart(jsonData);
                    resolved();
                }
            });
        });
    },

    // Update the cart information
    updateCartInformation: function (jsonData, addedFromProductPage) {
        ajaxCart.updateCart(jsonData);
        //reactive the button when adding has finished
        if (addedFromProductPage) {
            $('#add_to_cart button').removeAttr('disabled').removeClass('disabled');
            if (!jsonData.hasError || jsonData.hasError == false)
                $('#add_to_cart button').addClass('added');
            else
                $('#add_to_cart button').removeClass('added');
        }
        else
            $('.product-list__item__add-to-cart-button').removeAttr('disabled').removeClass('disabled');
    },

    // add a product in the cart via ajax
    add: function (idProduct, idCombination, addedFromProductPage, callerElement, quantity, whishlist) {

        if (addedFromProductPage && !checkCustomizations()) {
            if (contentOnly) {
                var productUrl = window.document.location.href + '';
                var data = productUrl.replace('content_only=1', '');
                window.parent.document.location.href = data;
                return;
            }

            return alert(fieldRequired);
        }

        //disabled the button when adding to not double add if user double click
        if (addedFromProductPage) {
            $('#add_to_cart button').prop('disabled', 'disabled').addClass('disabled');
            $('.filled').removeClass('filled');
        }
        else
            $(callerElement).prop('disabled', 'disabled');

        const requestParams = new URLSearchParams({
            controller: 'cart',
            add: 1,
            ajax: true,
            id_product: idProduct,
            ipa: (parseInt(idCombination) && idCombination != null) ? parseInt(idCombination) : null,
            id_customization: (typeof customizationId !== 'undefined' && customizationId) ? customizationId : 0,
            qty: quantity ? quantity : 1,
            token: static_token,
        });

        //send the ajax request to the server
        $.ajax({
            type: 'POST',
            headers: {"cache-control": "no-cache"},
            url: baseUri + '?rand=' + new Date().getTime(),
            async: true,
            cache: false,
            dataType: "json",
            data: requestParams.toString(),
            success: function (jsonData, textStatus, jqXHR) {
                // add appliance to whishlist module
                if (whishlist && !jsonData.errors)
                    WishlistAddProductCart(whishlist[0], idProduct, idCombination, whishlist[1]);

                if (!jsonData.hasError) {
                    /**
                     * Successfully added to the Cart
                     */
                    if (contentOnly) {
                        window.parent.ajaxCart.updateCartInformation(jsonData, addedFromProductPage);
                    } else {
                        ajaxCart.updateCartInformation(jsonData, addedFromProductPage);
                    }

                    if (jsonData.crossSelling) {
                        $('.crossseling').html(jsonData.crossSelling);
                    }

                    triggerAddToCartAnimation(document.querySelector('.brekz-header__shoppingcart'));

                    let addedProduct = jsonData.products.find((product) => product.id === parseInt(idProduct));
                    if (idCombination) {
                        addedProduct = jsonData.products.find((product) => product.id === parseInt(idProduct) && product.idCombination === parseInt(idCombination));
                    }

                    window.attemptToLogEventToFirebase('add_to_cart', {
                        'currency': 'EUR',
                        'item_id': idProduct,
                        'item_name': addedProduct.name,
                        'price': addedProduct.price,
                        'quantity': addedProduct.quantity,
                        'value': addedProduct.quantity * addedProduct.price,
                    });

                    if (contentOnly) {
                        window.parent.ajaxCart.updateLayer(jsonData, jsonData.products, addedProduct, true);
                    } else {
                        ajaxCart.updateLayer(jsonData, jsonData.products, addedProduct, true);
                    }


                    if (typeof window.pushGAEvent === 'function') {
                        window.pushGAEvent('add_to_cart', {
                            ecommerce: {
                                items: jsonData.products.map(product => {
                                    const productData = {
                                        item_id: product.id,
                                        item_name: product.name,
                                        item_variant: product.hasAttributes ? product.attributes : null,
                                        quantity: product.quantity,
                                        price: parseFloat(product.price_float),
                                        currency: product.currency
                                    };

                                    return Object.assign(productData, product.categories);
                                })
                            }
                        });
                    }

                    if (typeof window.getCopernicaWebTrackerSdk === 'function') {
                        window.getCopernicaWebTrackerSdk()
                              .then((copernica) => {
                                  copernica.trigger('cart-add', {
                                      'id': jsonData.idCart,
                                      'sku': addedProduct.id,
                                      'count': addedProduct.quantity,
                                  });
                              })
                              .catch((e) => {
                                  console.error(`Unable to send the cart-add event to Copernica`, e);
                              });
                    }

                    if (jsonData.shippingCostFloat === "0") {
                        $('.layer_cart_shipping').html('<span class="layer_cart_shipping">' + trans_shipping_costs + '</span><span class="text--green" style="float:right;">' + trans_free + '</span>');
                    } else {
                        $('.layer_cart_shipping').html('');
                    }


                    if (contentOnly) {
                        parent.$.fancybox.close();
                    }

                }
                else {
                    /**
                     * Failed to add to the Cart
                     */
                    if (contentOnly) {
                        window.parent.ajaxCart.updateCart(jsonData);
                    } else {
                        ajaxCart.updateCart(jsonData);
                    }
                }

                if (addedFromProductPage) {
                    $('#add_to_cart button').removeAttr('disabled').removeClass('disabled');
                } else {
                    $(callerElement).removeAttr('disabled').removeClass('disabled');
                }

                emptyCustomizations();

            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
                var error = "Impossible to add the product to the cart.<br/>textStatus: '" + textStatus + "'<br/>errorThrown: '" + errorThrown + "'<br/>responseText:<br/>" + XMLHttpRequest.responseText;
                if (!!$.prototype.fancybox)

                    $.fancybox.open([
                            {
                                type: 'inline',
                                autoScale: true,
                                minHeight: 30,
                                content: '<p class="fancybox-error">' + error + '</p>'
                            }],
                        {
                            padding: 0
                        });
                else
                    alert(error);
                //reactive the button when adding has finished
                if (addedFromProductPage)
                    $('#add_to_cart button').removeAttr('disabled').removeClass('disabled');
                else
                    $(callerElement).removeAttr('disabled');
            }
        });
    },

    //remove a product from the cart via ajax
    remove: function (idProduct, idCombination, customizationId, idAddressDelivery) {
        //send the ajax request to the server
        $.ajax({
            type: 'POST',
            headers: {"cache-control": "no-cache"},
            url: baseUri + '?rand=' + new Date().getTime(),
            async: true,
            cache: false,
            dataType: "json",
            data: 'controller=cart&delete=1&id_product=' + idProduct + '&ipa=' + ((idCombination != null && parseInt(idCombination)) ? idCombination : '') + ((customizationId && customizationId != null) ? '&id_customization=' + customizationId : '') + '&id_address_delivery=' + idAddressDelivery + '&token=' + static_token + '&ajax=true',
            success: function (jsonData) {
                ajaxCart.updateCart(jsonData);
                if ($('body').attr('id') == 'order' || $('body').attr('id') == 'order-opc')
                    deleteProductFromSummary(idProduct + '_' + idCombination + '_' + customizationId + '_' + idAddressDelivery);
            },
            error: function () {
                var error = 'ERROR: unable to delete the product';
                if (!!$.prototype.fancybox) {
                    $.fancybox.open([
                        {
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: error
                        }
                    ], {
                        padding: 0
                    });
                }
                else
                    alert(error);
            }
        });
    },

    //hide the products displayed in the page but no more in the json data
    hideOldProducts: function (jsonData) {
    },

    hideOldProductCustomizations: function (product, domIdProduct) {
    },

    doesCustomizationStillExist: function (product, customizationId) {
    },

    //refresh display of vouchers (needed for vouchers in % of the total)
    refreshVouchers: function (jsonData) {
    },

    // Update product quantity
    updateProductQuantity: function (product, quantity) {
        $('dt[data-id=cart_block_product_' + product.id + '_' + (product.idCombination ? product.idCombination : '0') + '_' + (product.idAddressDelivery ? product.idAddressDelivery : '0') + '] .quantity').fadeTo('fast', 0, function () {
            $(this).text(quantity);
            $(this).fadeTo('fast', 1, function () {
                $(this).fadeTo('fast', 0, function () {
                    $(this).fadeTo('fast', 1, function () {
                        $(this).fadeTo('fast', 0, function () {
                            $(this).fadeTo('fast', 1);
                        });
                    });
                });
            });
        });
    },

    //display the products witch are in json data but not already displayed
    displayNewProducts: function (jsonData) {
    },

    displayNewCustomizedDatas: function (product) {
        var content = '';
        var productId = parseInt(product.id);
        var productAttributeId = typeof(product.idCombination) == 'undefined' ? 0 : parseInt(product.idCombination);
        var hasAlreadyCustomizations = $('ul[data-id="customization_' + productId + '_' + productAttributeId + '"]').length;

        if (!hasAlreadyCustomizations) {
            if (!product.hasAttributes)
                content += '<dd data-id="cart_block_combination_of_' + productId + '" class="unvisible">';
            if ($('ul[data-id="customization_' + productId + '_' + productAttributeId + '"]').val() == undefined)
                content += '<ul class="cart_block_customizations" data-id="customization_' + productId + '_' + productAttributeId + '">';
        }

        $(product.customizedDatas).each(function () {
            var done = 0;
            customizationId = parseInt(this.customizationId);
            productAttributeId = typeof(product.idCombination) == 'undefined' ? 0 : parseInt(product.idCombination);
            content += '<li name="customization"><div class="deleteCustomizableProduct" data-id="deleteCustomizableProduct_' + customizationId + '_' + productId + '_' + (productAttributeId ? productAttributeId : '0') + '"><a rel="nofollow" class="ajax_cart_block_remove_link" href="' + baseUri + '?controller=cart&amp;delete=1&amp;id_product=' + productId + '&amp;ipa=' + productAttributeId + '&amp;id_customization=' + customizationId + '&amp;token=' + static_token + '"></a></div>';

            // Give to the customized product the first textfield value as name
            $(this.datas).each(function () {
                if (this['type'] == CUSTOMIZE_TEXTFIELD) {
                    $(this.datas).each(function () {
                        if (this['index'] == 0) {
                            content += ' ' + this.truncatedValue.replace(/<br \/>/g, ' ');
                            done = 1;
                            return false;
                        }
                    })
                }
            });

            // If the customized product did not have any textfield, it will have the customizationId as name
            if (!done)
                content += customizationIdMessage + customizationId;
            if (!hasAlreadyCustomizations) content += '</li>';
            // Field cleaning
            if (customizationId) {
                $('#uploadable_files li div.customizationUploadBrowse img').remove();
                $('#text_fields input').attr('value', '');
            }
        });

        if (!hasAlreadyCustomizations) {
            content += '</ul>';
            if (!product.hasAttributes) content += '</dd>';
        }
        return (content);
    },

    updateLayer: function (cartData, allProducts, addedProduct, openCartModal = false) {
        window.EventBus.$emit('block-cart-update', { cartData, allProducts, addedProduct, openCartModal });

        crossselling_serialScroll();
    },

    //genarally update the display of the cart
    updateCart: function (jsonData) {
        if (jsonData.hasError) {
            var errors = '';

                if (jsonData.errors) {
                    jsonData.errors.forEach(error => {
                        errors += error + '<br>'
                    })
                }

                if (jsonData.error) {
                    errors = jsonData.error
                }

                window.brekzModal({
                    title: jsonData.customtext ? jsonData.customtext.title : 'Unknown' ,
                    content: errors
                }, { centerButtons: true, show: true, width: 'xs' }, [{
                    text: jsonData.customtext ? jsonData.customtext.button_text : 'Close',
                    class: "button-brekz button-brekz--rounded button-brekz--green button--extra-large",
                    emit_name: "close"
                }])

        } else {
            this.products = jsonData.products;
            ajaxCart.updateCartEverywhere(jsonData);
            ajaxCart.hideOldProducts(jsonData);
            ajaxCart.displayNewProducts(jsonData);
            ajaxCart.refreshVouchers(jsonData);
            ajaxCart.updateLayer(jsonData, jsonData.products, null);

            //update 'first' and 'last' item classes
            $('.cart-popup .products dt').removeClass('first_item').removeClass('last_item').removeClass('item');
            $('.cart-popup .products dt:first').addClass('first_item');
            $('.cart-popup .products dt:not(:first,:last)').addClass('item');
            $('.cart-popup .products dt:last').addClass('last_item');
        }
    },

    //update general cart informations everywhere in the page
    updateCartEverywhere: function (jsonData) {
        $('.ajax_cart_total').text($.trim(jsonData.productTotal));

        if (jsonData.discounts.length > 0){
            jsonData.discounts.map((discount) => {
                $('.cart-popup__summary-list').append(`<div class="cart-popup__summary-list__item clearfix">
					<div class="cart-popup__key">${discount.name}</div>
					<div class="cart-popup__value cart-popup__discount"> - ${discount.price}</div>
					</div>`).after($('.cart-popup__summary-list__item--total'))
            })
        }


        if (typeof hasDeliveryAddress == 'undefined') {
            let hasDeliveryAddress = false;
        }

        if (parseFloat(jsonData.shippingCostFloat) > 0 || jsonData.nbTotalProducts < 1) {
            $('.ajax_cart_shipping_cost').text(jsonData.shippingCost);
        } else if (typeof (freeShippingTranslation) != 'undefined') {
            $('.ajax_cart_shipping_cost').html(freeShippingTranslation);
        }

        $('.ajax_cart_tax_cost').text(jsonData.taxCost);
        $('.cart-popup_wrapping_cost').text(jsonData.wrappingCost);
        $('.ajax_block_cart_total').text(jsonData.total);
        $('.ajax_block_products_total').text(jsonData.productTotal);
        $('.ajax_total_price_wt').text(jsonData.total_price_wt);

        if (parseFloat(jsonData.freeShippingFloat) > 0) {
            $('.ajax_cart_free_shipping').html(jsonData.freeShipping);
            $('.freeshipping').fadeIn(0);
        } else if (parseFloat(jsonData.freeShippingFloat) == 0) {
            $('.freeshipping').fadeOut(0);
        }

        this.nb_total_products = jsonData.nbTotalProducts;

        $('#vue-cart-badge-desktop').text(jsonData.nbTotalProducts);

        if (parseInt(jsonData.nbTotalProducts) > 0) {
            $('.ajax_cart_no_product').hide();
            $('.ajax_cart_quantity').text(jsonData.nbTotalProducts);
            /*
            BRESP-116: we don't want to show the badge/pill if there are no products (it shows an empty ball)
            therefore .ajax_cart_quantity is .hidden in account-links--mobile.tpl
            lets show it if we add a product
            */
            $('.ajax_cart_quantity').show();
            $('.btn__article-amount-icon').show();

            if (parseInt(jsonData.nbTotalProducts) > 1) {
                $('.ajax_cart_product_txt').each(function () {
                    $(this).hide();
                });

                $('.ajax_cart_product_txt_s').each(function () {
                    $(this).show();
                });
            }
            else {
                $('.ajax_cart_product_txt').each(function () {
                    $(this).show();
                });

                $('.ajax_cart_product_txt_s').each(function () {
                    $(this).hide();
                });
            }
        }
        else {
            $('.ajax_cart_quantity, .ajax_cart_product_txt_s, .ajax_cart_product_txt, .ajax_cart_total, .btn__article-amount-icon').each(function () {
                $(this).hide();
            });
            $('.ajax_cart_no_product').show('slow');
        }
    }
};

window.ajaxCart = ajaxCart;

function HoverWatcher(selector) {
    this.hovering = false;
    var self = this;

    this.isHoveringOver = function () {
        return self.hovering;
    }

    $(selector).hover(function () {
        self.hovering = true;
    }, function () {
        self.hovering = false;
    })
}

function crossselling_serialScroll() {
    if (!!$.prototype.bxSlider)
        $('#blockcart_caroucel').bxSlider({
            minSlides: 2,
            maxSlides: 4,
            slideWidth: 178,
            slideMargin: 20,
            moveSlides: 1,
            infiniteLoop: false,
            hideControlOnEnd: true,
            pager: false
        });
}
